/** Outline / secondary save: persist in KYD without Meta publish. */
export const SAVE_WITHOUT_PUBLISHING_LABEL = "Save draft";
